import React, { useState } from 'react';
import { GallectionType } from '@wix/da-shared-react/pkg/types/gallection';
import { normalizePremiumFolderData } from '@wix/da-shared-react/pkg/utils/normalizePremiumFolderData';
import { isGroup } from '@wix/da-shared-react/pkg/User/helpers';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import MediaManager, {
  getMediaSourceFromGallectionType,
} from '@wix/da-shared-react/pkg/MediaPopup/MediaManager';
import { ALL_FOLDER_ID } from '@wix/da-url';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';

import FolderCard, {
  Props as FolderCardProps,
} from '@wix/da-shared-react/pkg/FolderCard';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';

export interface Props extends FolderCardProps {
  profileOwnerUser: PapiUser;
  isProfileOwner: boolean;
}

const ProfileFolderCard: React.FC<Props> = ({
  className,
  folder,
  profileOwnerUser,
  isProfileOwner,
  ...props
}) => {
  const { t } = useTranslation();
  const gallery_thumb_premium_flow = useFlag('gallery_thumb_premium_flow');

  const [isMediaManagerShown, setShowMediaManager] = useState(false);

  const closeMediaManager = e => {
    setShowMediaManager(false);
    e && e.preventDefault();
    e && e.stopPropagation();
  };

  const { isPaidFolder } = normalizePremiumFolderData(folder.premiumFolderData);

  const showFooterMenu =
    gallery_thumb_premium_flow &&
    isProfileOwner &&
    !isGroup(profileOwnerUser) &&
    !isPaidFolder &&
    folder.folderId !== ALL_FOLDER_ID;

  return (
    <>
      <FolderCard
        folder={folder}
        {...props}
        extras={
          showFooterMenu && (
            <IconButtonWithContextMenu
              items={[
                {
                  label: t('folderCard.sell'),
                  onClick: e => {
                    setShowMediaManager(true);
                    e && e.preventDefault();
                    e && e.stopPropagation();
                  },
                },
              ]}
              onClick={e => {
                e && e.preventDefault();
                e && e.stopPropagation();
              }}
              withButton
            >
              <EllipsisIcon size={IconSize.MEDIUM} />
            </IconButtonWithContextMenu>
          )
        }
      />
      {isMediaManagerShown && (
        <MediaManager
          initialMediaSource={getMediaSourceFromGallectionType(
            GallectionType.GALLERY
          )}
          gruser={profileOwnerUser}
          gallectionFolder={folder}
          onDone={closeMediaManager}
          onClose={closeMediaManager}
        />
      )}
    </>
  );
};
ProfileFolderCard.displayName = 'ProfileFolderCard';

export default ProfileFolderCard;
